<template>
  <div id="app">
    <router-view/>
    <transition name="fade">
      <preloader v-show="$store.state.preload"/>
    </transition>
  </div>
</template>

<script>
import Preloader from './components/utils/Preloader.vue'

export default {
  name: 'App',
  components: { Preloader }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue